<span i18n="@@view">View</span>
<un-icon
  [ngClass]="{ active: display === 'grid' }"
  (click)="setDisplay('grid')"
  type="appstore"
></un-icon>
<un-icon
  [ngClass]="{ active: display === 'list' }"
  (click)="setDisplay('list')"
  type="unordered-list"
  theme="outline"
></un-icon>
